import { Component, ViewChild, ElementRef, OnInit } from '@angular/core'
import { Router } from "@angular/router"
import { AuthService } from '../../shared/auth.service'
import { GlobService } from 'src/app/shared/glob.service'
import { AlerterService } from 'src/app/shared/alerter.service'
import { AjaxService } from 'src/app/shared/ajax.service'
import * as $ from 'jquery'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  // glob: any = glob
  user_name: string
  password: string

  constructor(public glob: GlobService, private authService: AuthService, private router: Router, private alerter: AlerterService, private ajax: AjaxService) { }

  ngOnInit() {
    $('body').addClass('bgdoted')
    
  }

  ngAfterViewInit() {
    if ($('#user_name').val() != '') document.getElementById('password').focus();
    else document.getElementById('user_name').focus()
  }

  login() {
    // this.alerter.warning('کاربر عزیز سامانه برای مدت کوتاهی از دسترس خارج است');    return
    if (!this.user_name) { this.alerter.warning('نام کاربری الزامی است'); return }
    if (!this.password) { this.alerter.warning('رمز عبور الزامی است'); return }

    var data = {
      user_name: this.user_name.toLowerCase(),
      password: this.password,
      platform: navigator.platform,
      app_name: navigator.appCodeName + ' ' + navigator.appVersion,
      user_agent: navigator.userAgent,
      language: navigator.language
    }

    this.authService.login(data, () => {
      this.router.navigate(['/home/dashboard'])
    })

  }

  onKeydown(event) {
    let element = event.target
    if (event.key === "Enter") {
      switch (element.id) {
        case 'user_name':
          document.getElementById('password').focus()
          break
        case 'password':
          document.getElementById('login').click()
          break

      }
    }
  }
}